<template>
  <v-container class="mt-4" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title>
            <span class="text-subtitle-1">Matriz de Eisenhower</span>
            <v-spacer />
            <v-btn color="primary" dark small tile @click="abrirDialogo()">
              <v-icon left small>mdi-plus</v-icon>
              Nueva tarea
            </v-btn>

            <v-btn color="primary" dark small tile @click="initialize()" class="ml-2">
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col cols="12" md="6">
        <eisenhower-quadrante
          titulo="Urgente e Importante"
          subtitulo="Hacer ya"
          color="error"
          :tareas="cuadrante1"
          @editar="editarTarea"
          @eliminar="eliminarTarea"
          @toggle-completada="toggleCompletada"
        />
      </v-col>
      <v-col cols="12" md="6">
        <eisenhower-quadrante
          titulo="Importante, no urgente"
          subtitulo="Planificar"
          color="primary"
          :tareas="cuadrante2"
          @editar="editarTarea"
          @eliminar="eliminarTarea"
          @toggle-completada="toggleCompletada"
        />
      </v-col>
      <v-col cols="12" md="6">
        <eisenhower-quadrante
          titulo="Urgente, no importante"
          subtitulo="Delegar"
          color="warning"
          :tareas="cuadrante3"
          @editar="editarTarea"
          @eliminar="eliminarTarea"
          @toggle-completada="toggleCompletada"
        />
      </v-col>
      <v-col cols="12" md="6">
        <eisenhower-quadrante
          titulo="Ni urgente ni importante"
          subtitulo="Eliminar o reducir"
          color="black"
          :tareas="cuadrante4"
          @editar="editarTarea"
          @eliminar="eliminarTarea"
          @toggle-completada="toggleCompletada"
        />
      </v-col>
    </v-row>

    <!-- Diálogo nueva/editar tarea -->
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
        <v-card-title>{{ esEdicion ? 'Editar tarea' : 'Nueva tarea' }}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="form.titulo"
            label="Título"
            filled
            dense
            hide-details
            class="mb-2"
          />
          <v-checkbox v-model="form.urgente" label="Urgente" hide-details dense />
          <v-checkbox v-model="form.importante" label="Importante" hide-details dense />
          <v-textarea
            v-model="form.notas"
            label="Notas (opcional)"
            filled
            dense
            rows="2"
            auto-grow
          />

          <!-- Tabla de involucrados -->
          <div class="mt-4">
            <div class="text-subtitle-2 mb-2">Involucrados</div>
            <div
              v-for="(involucrado, index) in form.involucrados"
              :key="index"
              class="d-flex align-center mb-2"
            >
              <v-text-field
                v-model="form.involucrados[index]"
                :label="`Involucrado ${index + 1}`"
                filled
                dense
                hide-details
                class="flex-grow-1 mr-2"
              />
              <v-btn
                v-if="form.involucrados.length > 1"
                icon
                x-small
                color="error"
                @click="quitarInvolucrado(index)"
              >
                <v-icon small>mdi-minus</v-icon>
              </v-btn>
              <v-btn
                v-if="index === form.involucrados.length - 1"
                icon
                x-small
                color="primary"
                @click="agregarInvolucrado"
              >
                <v-icon small>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="cerrarDialogo">Cancelar</v-btn>
          <v-btn color="primary" @click="guardarTarea">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import EisenhowerQuadrante from '@/components/eisenhower/EisenhowerQuadrante.vue'

// Componentes
import Alerta                from '@/components/alertas/Alerta.vue'
import carga                 from '@/components/alertas/carga.vue';

import validarErrores        from '@/mixins/validarErrores'
import funcionesExcel        from '@/mixins/funcionesExcel'

export default {
  name: 'EisenhowerMatrix',
  components: { 
    EisenhowerQuadrante,
    Alerta,
    carga,
  },

  mixins: [ validarErrores, funcionesExcel ],

  data() {
    return {

      // Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      tareas: [],
      dialog: false,
      form: {
        id: null,
        titulo: '',
        urgente: false,
        importante: false,
        notas: '',
        completada: false,
        involucrados: ['']
      },
      usuarios: [],
      headersInvolucrados: [
        { text: 'Usuario', value: 'id_usuario' },
        { text: 'Nombre', value: 'nombre_completo' },
      ],
      involucrados: [],
    }
  },
  created() {
    this.initialize()
    this.getUsuarios()
  },


  computed: {
    ...mapGetters('login',['getdatosUsuarioERPERP']),

    cuadrante1() {
      return this.tareas.filter(t => t.urgente && t.importante)
    },
    cuadrante2() {
      return this.tareas.filter(t => !t.urgente && t.importante)
    },
    cuadrante3() {
      return this.tareas.filter(t => t.urgente && !t.importante)
    },
    cuadrante4() {
      return this.tareas.filter(t => !t.urgente && !t.importante)
    },
    esEdicion() {
      return this.form.idproblemas_criticos
    }
  },
  methods: {

    initialize () {
      this.cargar = true
      this.tareas = []

      return this.$http.get('kpi.problemas.criticos').then(async response=>{
        this.tareas     = response.data.problemasCriticos
        this.cargar = false
      }).catch( error =>{
        this.cargar = false
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },

    getUsuarios() {
      this.usuarios = []
      return this.$http.get('usuarios.all.erp').then(response=>{
        this.usuarios = response.data
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },


    abrirDialogo(tarea = null) {
      if (tarea) {
        const inv = tarea.involucrados
        let involucrados = ['']
        if (inv != null && inv !== '') {
          if (Array.isArray(inv)) {
            involucrados = inv.length ? inv.map(i => String(i).trim()) : ['']
          } else {
            involucrados = String(inv).split(',').map(s => s.trim()).filter(Boolean)
            if (!involucrados.length) involucrados = ['']
          }
        }
        this.form = {
          ...tarea,
          involucrados
        }
      } else {
        this.form = {
          id: null,
          titulo: '',
          urgente: false,
          importante: false,
          notas: '',
          completada: false,
          involucrados: ['']
        }
      }
      this.dialog = true
    },
    agregarInvolucrado() {
      this.form.involucrados.push('')
    },
    quitarInvolucrado(index) {
      this.form.involucrados.splice(index, 1)
    },
    cerrarDialogo() {
      this.dialog = false
    },

    guardarTarea() {
      if (!this.form.titulo.trim()) return

      if (this.form.idproblemas_criticos) {
        
        const datos = {
          ...this.form,
          involucrados: (this.form.involucrados || []).filter(i => i && String(i).trim())
        }

        return this.$http.post('kpi.problemas.criticos.update', datos ).then(async response=>{
          this.initialize()
          // Limpiar y cerrar el dialogo
          this.cerrarDialogo()
          this.cargar = false
        }).catch( error =>{
          this.cargar = false
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      } else {
        const involucrados = (this.form.involucrados || []).filter(i => i && String(i).trim())
        let payload = {
          titulo: this.form.titulo,
          urgente: this.form.urgente,
          importante: this.form.importante,
          notas: this.form.notas,
          completada: false,
          usuario_creo: this.getdatosUsuarioERPERP.iderp,
          involucrados
        }

        this.cargar = true

        return this.$http.post('kpi.problemas.criticos.add', payload ).then(async response=>{
          this.initialize()
          // Limpiar y cerrar el dialogo
          this.cerrarDialogo()
          this.cargar = false
        }).catch( error =>{
          this.cargar = false
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      }
      this.cerrarDialogo()
    },
    editarTarea(tarea) {
      console.log( tarea )
      this.form = tarea
      this.abrirDialogo(tarea)
    },
    eliminarTarea(tarea) {
      this.cargar = true
      tarea.deleted = 1
      return this.$http.post('kpi.problemas.criticos.update', tarea ).then(async response=>{
        this.initialize()
        // Limpiar y cerrar el dialogo
        this.cerrarDialogo()
        this.cargar = false
      }).catch( error =>{
        this.cargar = false
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },
    toggleCompletada(tarea) {
      this.cargar = true
      tarea.completada = tarea.completada == 1 ? 0 : 1
      return this.$http.post('kpi.problemas.criticos.update', tarea ).then(async response=>{
        this.initialize()
        // Limpiar y cerrar el dialogo
        this.cerrarDialogo()
        this.cargar = false
      }).catch( error =>{
        this.cargar = false
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })
    },
  

    cerrarDialogo() {
      this.dialog = false
      this.form = {
        id: null,
        titulo: '',
        urgente: false,
        importante: false,
        notas: '',
        involucrados: ['']
      }
    },
    
  }
}
</script>